import React, { useEffect } from 'react';
import expiry_pic from '../../images/expired_pic.png';
import no_access_pic from '../../images/no_permission.png';
import { useSearchParams } from 'react-router-dom';

const STATUS_CONFIG = {
  NP: {
    title: 'Form Unavailable',
    heading: 'Some updates are going on in the form at the moment. Please check back later',
    description: null,
    image: expiry_pic,
    imageAlt: 'Form temporarily unavailable',
  },
  RVK: {
    title: 'Access Denied',
    heading: "Sorry, you don't have permission",
    description: 'Please contact the person who shared the link with you.',
    image: no_access_pic,
    imageAlt: 'Access denied illustration',
  },
  DEFAULT: {
    title: 'Link Expired',
    heading: 'Sorry, the link has expired',
    description: 'Please contact the person who shared the link with you.',
    image: expiry_pic,
    imageAlt: 'Expired link illustration',
  },
};

const LinkExpiryPage = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status');
  const config =
    status === 'NP'
      ? STATUS_CONFIG.NP
      : status === 'RVK'
        ? STATUS_CONFIG.RVK
        : STATUS_CONFIG.DEFAULT;

  useEffect(() => {
    document.title = `${config.title} | Data Collection Studio`;
    return () => {
      document.title = 'Data Collection Studio';
    };
  }, [config.title]);

  return (
    <main className="link-expiry-page" aria-labelledby="link-expiry-heading">
      <div className="link-expiry-page__card">
        <div className="link-expiry-page__image">
          <img src={config.image} alt={config.imageAlt} width={280} height={200} />
        </div>
        <h1 id="link-expiry-heading" className="link-expiry-page__heading">
          {config.heading}
        </h1>
        {config.description && (
          <p className="link-expiry-page__description">{config.description}</p>
        )}
      </div>
    </main>
  );
};

export default LinkExpiryPage;
